import auth from '@/router/auth'
import CategoryItemIndex from '@/components/schools/Index'
import CategoryItemCreate from '@/components/schools/Create'
import CategoryItemUpdate from '@/components/schools/Update'
import CategoryItemShow from '@/components/schools/Show'
import CategoryItemConfig from '@/components/schools/Config'
import CategoryItemTeacher from '@/components/schools/Teacher'

export default [
  {
    path: '/schools',
    name: 'schools-index',
    component: CategoryItemIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/schools/create',
    name: 'schools-create',
    component: CategoryItemCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/schools/update/:id',
    name: 'schools-update',
    component: CategoryItemUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/schools/update-config/:id',
    name: 'schools-update-config',
    component: CategoryItemConfig,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/schools/update-teacher/:id',
    name: 'schools-update-teacher',
    component: CategoryItemTeacher,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/schools/show/:id',
    name: 'schools-show',
    component: CategoryItemShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/schools/router.js